import {
  UnavailableReceiptView,
  ReceiptLineItems,
  ReceiptClaimCtaBanner,
  Claim,
} from './components';

export { useReceiptQuery, type ReceiptQuery } from './GraphQL/Receipt.generated';

export const Receipt = {
  UnavailableView: UnavailableReceiptView,
  LineItems: ReceiptLineItems,
  ClaimBanner: ReceiptClaimCtaBanner,
  Claim,
};

export { useReceiptMachine } from './machine';
